import axios from 'axios';
import router from '../router';
import {removeToken} from "../utils/auth";
// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.code == 997) {
            let tip = $vue.$createToast({
                txt: '会员已在其他设备登录！',
                type: "txt"
            })
            tip.show();
            removeToken();
            router.push("/login");
            return Promise.reject(response);
        }
        if (response.data.code == 996) {
            let tip = $vue.$createToast({
                txt: '请联系管理员！',
                type: "txt"
            })
            tip.show();
            return Promise.reject(response);
        } else {
            if (response.status === 200) {
                return Promise.resolve(response);
            } else {
                return Promise.reject(response);
            }
        }

    },
    // error => {
    //     router.push('/error')
    // }
);

